import { useStaticQuery, graphql } from "gatsby"
import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image";
import { isMobile } from "react-device-detect"

const StyledQRCode = styled(GatsbyImage)`
    background-color: black;
    width: 5rem;
    height: 5rem;
    border-radius: 4px;
    margin-top: 0.8rem;
    padding: 1rem;
    display: ${isMobile ? "none" : "block"};
    margin-left: 0.8rem;
`

const QRImage = ({ img, ...props }) => {
    return <StyledQRCode imgStyle={{ objectFit: "contain" }} fluid={img} />
}

const QRCode = ({ size }) => {
    const data = useStaticQuery(graphql`{
  qrImg: file(relativePath: {eq: "KingChildren/appqrcode.png"}) {
    childImageSharp {
      gatsbyImageData(width: 900, layout: CONSTRAINED)
    }
  }
}
`)
    return <QRImage img={data.qrImg.childImageSharp.gatsbyImageData} />;
}

export default QRCode
